import { render, staticRenderFns } from "./OsGlobalSearch.vue?vue&type=template&id=3ffb0540&scoped=true"
import script from "./OsGlobalSearch.vue?vue&type=script&lang=ts"
export * from "./OsGlobalSearch.vue?vue&type=script&lang=ts"
import style0 from "./OsGlobalSearch.vue?vue&type=style&index=0&id=3ffb0540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb0540",
  null
  
)

export default component.exports